import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';

export interface AddInvestigationInvolvedEmployeesCommand { investigationId: string; userIds: string[]; }

@Injectable({ providedIn: 'root' })
export class AddInvestigationInvolvedEmployeesUseCase {
  private readonly _repository = inject(InvestigationsRepository);

  public execute(command: AddInvestigationInvolvedEmployeesCommand): Observable<void> {
    return this._repository.addInvolvedEmployees(command.investigationId, command.userIds);
  }
}
